import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Schuif from "../../doors/schuif";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import { mirrorVerticalBeamPosition } from "entities/configurator/model/layoutMeta";

interface DoubleSchuifProps extends ConfigurationProps {}
const DoubleSchuif: React.FC<DoubleSchuifProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: DoubleSchuifProps) => {
  const position0 = new Vector3(-0.459, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);

  const { eigenwijs, getConfigurationPositions, sceneStaanderPosition } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1]));
  }, [eigenwijs?.sizeObjects]);

  const verticalBeamPosition = mirrorVerticalBeamPosition(
    sceneStaanderPosition,
  );

  return (
    <group position={position} scale={scale}>
      <Schuif
        materials={materials}
        position={positions[0]}
        rotation={rotation}
        index={0}
        frameSettings={doorSettings?.main?.frameSettings}
        railSettings={doorSettings?.main?.railSettings}
        verticalBeamPosition={verticalBeamPosition}
      />
      <Schuif
        materials={materials}
        position={positions[1]}
        index={1}
        frameSettings={doorSettings?.secondary?.frameSettings}
        railSettings={doorSettings?.secondary?.railSettings}
        verticalBeamPosition={verticalBeamPosition}
      />
    </group>
  );
};

export default DoubleSchuif;
